import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import HeaderFixed from '../../components/MainLayout/HeaderFixed';
import Loading from '../../components/Loading';
import AboutBanner from './AboutBanner';
import Certifications from './Certifications';
import Info from './Info';
import Team from './Team';
import { getTeamMembers } from '../../redux/dynamic_data/dynamicDataSlice';
import { updateMetaTitle, updateMetaDescription, updateMetaKeywords } from '../../helpers/utils';

function About() {
    const dispatch = useDispatch();

    const [dataLoaded, setDataLoaded] = useState(false);
    // const [teamDataLoaded, setTeamDataLoaded] = useState(false);
    const [certificationsDataLoaded, setCertificationsDataLoaded] = useState(false);

    const aboutPage = useSelector((state) => state.staticData.aboutPage);
    // const boardMembers = useSelector((state) => state.dynamicData.boardMembers);
    // const executiveLeadership = useSelector((state) => state.dynamicData.executiveLeadership);
    // const seniorLeadership = useSelector((state) => state.dynamicData.seniorLeadership);
    const certifications = useSelector((state) => state.dynamicData.certifications);

    useEffect(() => {
        // if (boardMembers.length !== 0) {
        //     setTeamDataLoaded(true);
        // }
        if (certifications.length !== 0) {
            setCertificationsDataLoaded(true);
        }
    }, [certifications]); //[boardMembers, certifications]

    useEffect(() => {
        if (aboutPage) {
            setDataLoaded(true);
        }
    }, [aboutPage])

    useEffect(() => {
        dispatch(getTeamMembers());
    }, [dispatch]);

    useEffect(() => {
        updateMetaDescription(aboutPage?.meta_data?.meta_description);
        updateMetaKeywords(aboutPage?.meta_data?.meta_keywords);
        if (aboutPage?.meta_data?.meta_title) {
            updateMetaTitle(aboutPage?.meta_data?.meta_title);
        } else {
            updateMetaTitle('Haydon - About');
        }
    }, [aboutPage]);

    return (
        !dataLoaded ? (
            <Loading />
        ) : (
            <div className="about-page">
                <HeaderFixed activeTab="about-haydon" />
                <AboutBanner data={aboutPage?.section_1} />
                <Info data={aboutPage?.section_2} />
                {/* {teamDataLoaded && (
                    <Team
                        data={aboutPage?.section_3}
                        boardMembers={boardMembers}
                        executiveLeadership={executiveLeadership}
                        seniorLeadership={seniorLeadership}
                    />
                )} */}
                <Team
                    data={aboutPage?.section_3}
                />
                {certificationsDataLoaded && (
                    <Certifications data={aboutPage?.section_4} certifications={certifications} />
                )}
            </div>
        )
    );
};

export default About;